import { useCallback } from 'react'
import { useDetailUserMutation } from '../api/ester-b2b-api/private/users/userQueries'
import { normalizePersonalNumber } from '@estercare/ester-shared'
import { TFunction } from 'i18next'
import { queryErrorHandlerWithMessage } from '../utils/queryErrorHandler'
import { useUserStore } from '../state/store'

export const usePersonalNumber = () => {
  const { mutate: updateUserDetailMutation } = useDetailUserMutation()

  const savePersonalNumber = useCallback(
    (params: { personalNumber: string; isValid: boolean; setError: (value: string) => void; t: TFunction }) => {
      const { personalNumber, isValid, setError, t } = params

      return new Promise<void>((resolve, reject) => {
        if (isValid && personalNumber) {
          const normalized = normalizePersonalNumber(personalNumber)
          updateUserDetailMutation(
            {
              newUserData: {
                personalNumber: normalized,
              },
            },
            {
              onSuccess: () => {
                const { user, setUser } = useUserStore.getState()
                if (user) setUser({ ...user, personalNumber: normalized })
                resolve()
              },
              onError: (error) => {
                const message = queryErrorHandlerWithMessage('update personal number', t)(error)
                setError(message)
                reject(error)
              },
            }
          )
        } else {
          resolve()
        }
      })
    },
    [updateUserDetailMutation]
  )

  return { savePersonalNumber }
}
